module.exports = __webpack_public_path__ + "static/media/escudo_universidad.cb0f6c19.webp";